<template>
  <!-- 素材上传 -->
  <div class="Uploadpagem">
    <div class="box">
      <div class="box-ceter">
        <h4 class="h4size">首页 > 素材上传</h4>
        <div class="Uploadarea">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :auto-upload="false"
            :on-change="picthandleChange"
            :show-file-list="false"
          >
            <div class="sctsd">
              <i class="iconfont gos-24gf-folderOpen gos"></i>
            </div>
            <el-button
              style="
                width: 99px;
                margin-top: 20px;
                height: 28px;
                background: #4ccaff;
                border-radius: 6px;
                padding: 0px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
              "
              ><em>点击上传</em></el-button
            >
            <div class="el-upload__text">
              <div class="ssra1" style="margin-bottom: 15px; font-size: 14px">
                也可以拖拽倒这里上传
              </div>
              <div class="ssra2">支持 JPEG, JPG, PNG, GIF, AVI, MP4等</div>
              <div class="ssra3">注意：图片不得超过30M，视频不得超过500M</div>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
          </el-upload>
          <img :src="imageUrl" alt="" />
        </div>
        <div class="nav-oad">
          <div style="display: flex">
            <h4 class="nav-upload">上传列表</h4>
            <span>请于上传之日起7天内提交审核，否则草稿将被删除</span>
          </div>

          <el-button type="primary" @click="pahsires()">查看已保存</el-button>
        </div>
        <ul>
          <li class="Draftbox" v-for="item in tepslat" :key="item.id">
            <video
              v-if="item.wjgs === '视频'"
              :src="http + item.scwj"
              controls
              style="
                width: 246px;
                height: 150px;
                opacity: 0.8;
                border-radius: 6px;
              "
            ></video>
            <img v-else :src="http + item.scwj" alt="" />
            <div class="certer">
              <el-form
                :inline="true"
                :model="formInline"
                :rules="rules"
                ref="formInline"
                class="demo-form-inline"
              >
                <el-form-item label="文件标题" size="mini" prop="user">
                  <el-input
                    style="width: 200px"
                    v-model="item.scmc"
                    placeholder="请输入文件标题"
                  ></el-input>
                </el-form-item>
                <div class="smis">
                  <div class="pss">建议：使用场景+文件描述+详细描述</div>
                  <div class="pss">
                    例如：课件制作（使用场景）+头部穴位（文件描述）+大脑穴（详细描述）
                  </div>
                </div>
                <el-form-item label="文件类型" size="mini" prop="region">
                  <el-select
                    style="width: 200px"
                    v-model="item.sort"
                    placeholder="请选择文件类型"
                  >
                    <el-option
                      v-for="item in Majorcategories"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="right-bottom">
              <el-button
                class="sch"
                style="margin-top: 40px"
                type="danger"
                @click="delmaterial(item)"
                >删除</el-button
              >
              <el-button
                class="lasez"
                style="margin-top: 10px"
                type="primary"
                @click="submitForm(item)"
                >保存</el-button
              >
              <el-button
                class="lasez"
                style="margin-top: 10px"
                type="primary"
                @click="Fileupload(item)"
                >提交素材</el-button
              >
            </div>
          </li>
        </ul>
        <div class="boytrtr">
          <el-button
            type="primary"
            v-if="tepslat.length >= 2"
            @click="Alltheupload()"
            >上传全部</el-button
          >
          <el-pagination
            class="spage"
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChangess"
            background
            :page-size="tepage.rows"
            layout="prev, pager, next"
            :total="tepage.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  insmaterial,
  selusersc,
  selsort,
  updmaterial,
  updmaterialsp,
  delmaterial,
} from "@/api/patient";
export default {
  data() {
    return {
      tepage: {
        page: 1,
        rows: 3,
        total: 100,
      },
      tepslat: {},
      http: this.$store.state.https,
      Thepicture: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imageUrl: "",
      formInline: {
        region: "",
        user: "",
        regiosnss: "",
      },
      width: "21321",
      height: "",
      Majorcategories: "",
      id: this.$store.state.user.id,
      rules: {
        // user: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
        // region: [
        //   { required: true, message: '请填写活动形式', trigger: 'blur' }
        // ],
        // regiosnss: [
        //   { required: true, message: '请输入活动名称', trigger: 'blur' }
        // ]
      },
    };
  },
  created() {
    // this.id = this.$store.state.user.

    this.selmaterialis();
    this.selsortis();
  },
  methods: {
    // 全部上传
    async Alltheupload() {
      var isss = 0;
      const set = []; // set 自带去重
      for (let s = 0; s < this.tepslat.length; s++) {
        var datas = new FormData();
        datas.append("id", this.tepslat[s].id);
        datas.append("scwj", this.tepslat[s].scwj);
        datas.append("scmc", this.tepslat[s].scmc);
        datas.append("scgs", this.tepslat[s].scgs);
        datas.append("sccc", this.tepslat[s].sccc);
        datas.append("wjgs", this.tepslat[s].wjgs);
        datas.append("sort", this.tepslat[s].sort);
        await updmaterial(datas).then((res) => {});
        if (!set.includes(this.tepslat[s].id)) {
          set.push(this.tepslat[s].id);
        }
      }
      for (let l = 0; l < this.tepslat.length; l++) {
        if (
          this.tepslat[l].sort === "" ||
          this.tepslat[l].sort === null ||
          this.tepslat[l].scmc === "" ||
          this.tepslat[l].scmc === null
        ) {
          isss++;
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
      }
      if (isss === 0) {
        var data = new FormData();
        data.append("ids", set);
        data.append("status", "审批中");
        await updmaterialsp(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: "上传成功",
              type: "success",
            });
            this.selmaterialis();
          }
        });
      }
    },
    pahsires() {
      this.$store.commit("Stateofsss", "已保存");
      this.$router.push("/Materialtoupload");
    },
    // 删除
    delmaterial(item) {
      var data = new FormData();
      data.append("ids", item.id);
      delmaterial(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 文件上传
    async Fileupload(item) {
      if (item.scmc) {
        if (item.sort) {
          var data = new FormData();
          data.append("id", item.id);
          data.append("scwj", item.scwj);
          data.append("scmc", item.scmc);
          data.append("scgs", item.scgs);
          data.append("sccc", item.sccc);
          data.append("wjgs", item.wjgs);
          data.append("sort", item.sort);
          await updmaterial(data).then((res) => {});

          var datas = new FormData();
          datas.append("ids", item.id);
          datas.append("status", "审批中");
          await updmaterialsp(datas).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: "上传成功",
                type: "success",
              });
              this.selmaterialis();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件保存
    submitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            this.selmaterialis();
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      selsort(data).then((res) => {
        this.Majorcategories = res.rows;
      });
    },
    // 素材已保存列表
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("id", this.$store.state.user.id);
      data.append("status", "已保存");
      selusersc(data).then((res) => {
        this.tepslat = res.rows;
        this.tepage.total = res.total;
      });
    },
    // 素材图片尺寸
    insmaterial(file) {
      const img = new Image();
      img.src = URL.createObjectURL(file.raw);

      return new Promise((resolve, reject) => {
        img.onload = () => {
          sessionStorage.setItem("height", img.height);
          sessionStorage.setItem("width", img.width);
          resolve(true);
        };
      });
    },
    // 视频尺寸
    getVideoMsg(file) {
      return new Promise((resolve) => {
        const videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", () => {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    // 图片参数
    async picthandleChange(file, fileList) {
      if (
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/gif"
      ) {
        await this.insmaterial(file);
      }

      if (file.raw.type === "video/mp4") {
        await this.getVideoMsg(file.raw).then((videoinfo) => {
          sessionStorage.setItem("sheight", videoinfo.height);
          sessionStorage.setItem("swidth", videoinfo.width);
        });
      }

      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/gif" ||
        file.raw.type === "video/mp4";

      const isLt2M =
        file.raw.type === "video/mp4"
          ? file.raw.size / 1024 / 1024 < 500
          : file.raw.size / 1024 / 1024 < 30;

      if (!isJPG) {
        this.$message({
          showClose: true,
          message: "上传图片或视频只能是 png/jpg/jpeg/gif/mp4 格式!",
          type: "error",
        });
      }

      if (!isLt2M) {
        this.$message({
          showClose: true,
          message:
            "上传图片或视频，图片大小不能超过 30MB!视频大小不能超过500MB!",
          type: "error",
        });
      }

      if (isJPG && isLt2M) {
        var arr = file.raw.name.split(".");
        var data = new FormData();
        data.append("scwj1", file.raw);
        data.append("scmc", arr[0]);
        data.append("scgs", arr[1]);
        data.append("userid", this.$store.state.user.id);
        if (arr[1] === "png" || arr[1] === "jpg" || arr[1] === "jpeg") {
          data.append("wjgs", "图片");
          data.append(
            "sccc",
            sessionStorage.getItem("width") +
              "*" +
              sessionStorage.getItem("height")
          );
        }
        if (arr[1] === "mp4" || arr[1] === "avi") {
          data.append("wjgs", "视频");
          data.append(
            "sccc",
            sessionStorage.getItem("swidth") +
              "*" +
              sessionStorage.getItem("sheight")
          );
        }
        if (arr[1] === "gif") {
          data.append("wjgs", "动图");
          data.append(
            "sccc",
            sessionStorage.getItem("width") +
              "*" +
              sessionStorage.getItem("height")
          );
        }
        data.append("status", "已保存");
        await insmaterial(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: "上传成功",
              type: "success",
            });
            this.selmaterialis();
          } else {
            return false;
          }
        });
      }
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
};

// function fileChoosed (event) {
//   console.log('aa')
//   const file = event.target.files[0]
//   const fileName = file.name
//   const img = document.getElementById('a')
//   const fr = new FileReader()
//   // const ts = this
//   fr.addEventListener('load', () => {
//     const blob = 'a'
//     console.log(fileName, img, blob) // 这里能获取到三个变量
//     img.onload = () => { // 不建议在浏览器里直接用箭头函数，支持不好
//       debugger
//       console.log(fileName, img, blob)
//       //  经过测试是可以打印这三个变量的
//     }
//     img.src = fr.result
//   })
//   fr.readAsDataURL(file)
// }
</script>
<style lang="scss" scoped>
.Uploadpagem {
  width: 100%;
  background: #ffffff;
  //   height: 100%;
  margin-top: 4px;
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  .box {
    width: 1090px;
    min-height: 1200px;
    text-align: left;
    margin: 0 auto;
    padding-top: 20px;
    .box-ceter {
      padding: 0 38px;
      padding-bottom: 78px;
      .Uploadarea {
        width: 1042px;
        height: 397px;
        background: #ffffff;
        border: 1px solid #ededed;
        text-align: center;
        padding-top: 35px;
        .upload-demo {
          width: 1011px;
          height: 363px;
          background: #f6f6f6;
          margin: 0 auto;
          ::v-deep .el-upload {
            width: 1011px;
            height: 363px;
            background: #f6f6f6;
            .el-upload-dragger {
              width: 1011px;
              height: 363px;
              background: #f6f6f6;
              .el-upload__text {
                font-size: 12px;
                margin-top: 20px;
                color: #666666;
                .ssra2 {
                  font-size: 13px;
                  margin: 10px 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

.h4size {
  height: 12px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #bdbdbd;
  margin-bottom: 21px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 1011px;
  height: 363px;
  background: #f6f6f6;
  line-height: 363px;
  text-align: center;
}
.avatar {
  width: 1011px;
  height: 363px;
  background: #f6f6f6;
  display: block;
}
.nav-oad {
  margin-top: 40px;
  margin-bottom: 28px;
  display: flex;
  justify-content: space-between;
  .nav-upload {
    height: 22px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  span {
    margin-left: 10px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 32px;
  }
  .el-button {
    padding: 0px;
    text-align: center;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    line-height: 30px;
    border: 0;
  }
}
.Draftbox {
  display: flex;
  width: 1000px;
  height: 150px;
  background: #ffffff;
  border: 1px solid #ededed;
  //   line-height: 190px;
  padding: 20px 20px;
  img {
    width: 246px;
    height: 150px;
    opacity: 0.8;
    border-radius: 6px;
  }
  .certer {
    margin-left: 22px;
    .demo-form-inline {
      .el-form-item {
        height: 30px;
        margin-bottom: 15px;
        ::v-deep .el-form-item__label {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 34px;
        }
      }
      .smis {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 27px;
        margin-bottom: 15px;
        padding-left: 68px;
        p {
          height: 10px;
        }
      }
    }
  }
  .right-bottom {
    display: flex;
    flex-direction: column;
    width: 99px;
    margin-left: 83px;
    button {
      margin: 0px;
      padding: 0;
      width: 99px;
      height: 28px;
      border-radius: 6px;
      border: 0;
    }
    .lasez {
      background: #4ccaff;
    }
    .lasez:hover {
      background: #4ccaffc9;
    }
    .sch:hover {
      background: #f56c6cc7;
    }
  }
}
ul {
  padding-bottom: 50px;
  min-height: 526px;
}
.boytrtr {
  text-align: center;
  //  margin-bottom:78px ;
  .el-button {
    padding: 0;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    border: 0px;
    margin-bottom: 20px;
  }
  .spage {
  }
}
.el-button:hover {
  background: #4ccaffc9;
}
.gos {
  padding: 27px;
  font-size: 37px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  color: #4ccaff;
}
.sctsd {
  margin-top: 76px;
  margin-bottom: 20px;
}
.ssra3 {
  font-size: 12px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Uploadpagem {
    .box {
      width: 100vw;
      .box-ceter {
        padding: 0 10px;
        padding-bottom: 78px;

        .wzbj {
          display: block;
          .wzzs {
            width: 95vw;
            .searchbox {
              width: 80vw;
            }
            .appdsa {
              left: 65vw;
            }
            .sclb {
              width: 90vw;
            }
          }
        }

        .top {
          .top-Major {
            width: 95vw;
            flex-shrink: 0; /* 防止项目在空间不足时缩小 */
            white-space: nowrap; /* 确保项目不换行 */
            /* 样式调整，根据需要设置宽度、间距等 */
            margin-right: 10px;
            /* 其他样式 */
            overflow-x: auto;
          }
        }
        .Uploadarea {
          width: 95vw;
          .upload-demo {
            width: 90vw;
            ::v-deep .el-upload {
              width: 90vw;
              .el-upload-dragger {
                width: 90vw;
              }
            }
          }
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    line-height: 363px;
    text-align: center;
  }
  .avatar {
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    display: block;
  }
  .nav-oad {
    display: flex;
    .nav-upload {
      width: 120px;
    }
    span {
      display: none;
    }
  }
  .Draftbox {
    display: block;
    width: 90vw;
    height: 400px;
    background: #ffffff;
    padding: 10px 10px;

    img {
      width: 246px;
      height: 150px;
      opacity: 0.8;
      border-radius: 6px;
    }
    .certer {
      margin-left: 2px;
      margin-top: 10px;
      .demo-form-inline {
        .el-form-item {
          height: 30px;
          margin-bottom: 15px;
          ::v-deep .el-form-item__label {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            line-height: 34px;
          }
        }
        .smis {
          padding-left: 0px;
          width: 80vw;
        }
      }
    }
    .right-bottom {
      display: flex;
      flex-direction: row-reverse;
      width: 90vw;
      margin-left: -13px;
      button {
        margin: 0px;
        padding: 0;
        width: 99px;
        height: 28px;
        border-radius: 6px;
        border: 0;
      }
      .lasez {
        background: #4ccaff;
      }
      .lasez:hover {
        background: #4ccaffc9;
      }
      .sch {
        margin-top: 10px !important;
      }
      .sch:hover {
        background: #f56c6cc7;
      }
    }
  }
}
</style>
